import classNames from 'classnames'
import React from 'react'
import { useId } from 'react'
import styles from './SelectableFilter.module.scss'
import type { SelectableFilterProps } from './types'
import { SelectableFilterSize, SelectableFilterState } from './types'
import { Blob05, CheckCircleIcon, Illustration, IllustrationSize } from '@/tools/ui'

const mapperSizes = {
  [SelectableFilterSize.medium]: IllustrationSize.medium,
  [SelectableFilterSize.small]: IllustrationSize.small,
}

export const SelectableFilter: React.FC<SelectableFilterProps> = ({
  className,
  imgAlt = '',
  imgSrc,
  isSelected = false,
  size = SelectableFilterSize.small,
  onClick,
  title,
  ...props
}) => {
  const illustrationSize = mapperSizes[size] || IllustrationSize.small
  const id = useId()

  const handleOnClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClick?.(event)
  }

  return (
    <div
      aria-labelledby={id}
      className={styles.selectableFitler}
      data-selected={isSelected ? SelectableFilterState.selected : SelectableFilterState.unselected}
      data-size={size}
      role="button"
      onClick={handleOnClick}
    >
      <div className={classNames(styles.blob, className)} {...props}>
        <div className={styles.shape}>
          <Blob05 />
        </div>
        <div className={styles.illustration}>
          {imgSrc && <Illustration alt={imgAlt} size={illustrationSize} src={imgSrc} />}
        </div>
      </div>
      <CheckCircleIcon className={styles.icon} outline={false} />

      <p className={classNames(styles.title, 'pintxo-typography-caption-emphasis')} id={id}>
        {title}
      </p>
    </div>
  )
}
